import React, { memo } from 'react';
import { View, StyleSheet } from 'react-native';
import Text from 'design-system/Text';
import IconShieldFail from 'design-system/icons/IconShieldFail';
import { Button, rem, SettingsSection, Spacer } from 'design-system';
import { formatPlural } from 'utils';
import { useAppSelector } from 'store/hooks';
import { selectTotalBreaches } from 'features/feed/selectors';
import Squircle from 'design-system/Squircle';
import useColors from 'hooks/useColors';
import { benefits, tierThemes } from 'features/premium/benefits';
import { selectTryFor0Text } from 'features/premium/selectors';
const UpgradeToUnlockFraud = ({ hideCard, isUnlocked, onPressUpgrade, }) => {
    const breachesInfo = useAppSelector(selectTotalBreaches);
    const colors = useColors();
    const tryFor0Text = useAppSelector(selectTryFor0Text);
    if (isUnlocked || hideCard)
        return null;
    return (<SettingsSection noMarginTop style={styles.card}>
      <View style={styles.container}>
        <Squircle color={colors.elements.statusNegativeLight}>
          <IconShieldFail colorKey="statusNegative"/>
        </Squircle>
        <Spacer.H16 />
        <Text Text-16>
          {breachesInfo.totalNumberOfBreaches}{' '}
          {formatPlural('breach', 'breaches', breachesInfo.totalBreaches)}{' '}
          found!
        </Text>
        <Spacer h={4}/>
        <Text TextThin-14 centered Secondary>
          {`Upgrade to ${tierThemes[benefits.dataProtection.minTier].name} see what companies have\nbeen hacked and have leaked your personal information to public databases`}
        </Text>
        <Spacer.H16 />
        <Button hug brandReversed small title={tryFor0Text ?? 'Upgrade'} onPress={onPressUpgrade} containerStyle={styles.btn}/>
      </View>
    </SettingsSection>);
};
export default memo(UpgradeToUnlockFraud);
const styles = StyleSheet.create({
    card: {
        marginBottom: rem(16),
    },
    container: {
        alignItems: 'center',
        paddingVertical: rem(24),
        paddingHorizontal: rem(16),
    },
    btn: {
        paddingHorizontal: rem(52),
    },
});
